import React from 'react'
import { classes, mediumContainer } from '../utils/components'
import styles from './colorable-simple-block.module.css'
import SimpleBlock from './simple-block'

const ColorableSimpleBlock = ({
  className,
  backgroundColor,
  title,
  description,
}) => (
  <div
    className={classes(
      'py-10 md:px-12',
      mediumContainer,
      backgroundColor || 'bg-brand-cyan',
      className
    )}
  >
    <SimpleBlock
      className={styles.content}
      centered={false}
      title={title}
      description={description}
    />
  </div>
)

export default ColorableSimpleBlock
